import {
  Box,
  Modal as MuiModal,
  Typography,
  Grid,
  IconButton,
  SxProps,
  Theme,
} from '@mui/material';
import * as React from 'react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

type ModalProps = {
  title: string;
  children: React.ReactNode;
  open: boolean;
  setOpen: (open: boolean) => void;
  onClose?: () => void;
  styles?: any;
};

export default function Modal(props: ModalProps) {
  return (
    <MuiModal
      open={props.open}
      onClose={props.onClose ?? (() => props.setOpen(false))}
      aria-labelledby='modal-modal-title'
    >
      <Box sx={styles.mainContainer}>
        <Grid container sx={{ flexDirection: 'column' }}>
          <Grid container item sx={[styles.modalText, props.styles]}>
            <Grid item>
              <Typography id='modal-modal-title' variant='h5' component='h2'>
                {props.title}
              </Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={props.onClose ?? (() => props.setOpen(false))}>
                <CloseRoundedIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Grid item>{props.children}</Grid>
        </Grid>
      </Box>
    </MuiModal>
  );
}

const styles = {
  mainContainer: {
    flexDirection: 'column',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 800,
    minWidth: 375,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
    overflow: 'auto',
    maxHeight: '80%',
  },
  modalText: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
};
